import DefaultBoxContainer from "./default-box-container";
import LiteBoxContainer from "./lite-box-container";
import UniversityBoxContainer from "./university-box-container";

export default {
  DefaultBoxContainer,
  LiteBoxContainer,
  UniversityBoxContainer,
};
